import React, { useEffect, useRef } from 'react'
import { useSelector, useDispatch } from 'react-redux'

import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import MarginWrapper from '../../features/wrappers/MarginWrapper'
import isMobileView from '../../util/MobileView'

import { EditAccountContainer } from '../../features/EditAccount/EditAccountContainer'

import EditSecondaryEmailDesktop from './EditSecondaryEmailDesktop'
import EditSecondaryEmailMobile from './EditSecondaryEmailMobile'

import {
  fetchUser, selectUserObject, selectUserCallStatus, updateUser
} from '../../features/user/userSlice'

import { setSecondaryEmail } from './editSecondaryEmailSlice'

export function EditSecondaryEmail() {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const values = useSelector((state) => state.editSecondaryEmail)
  const profile = useSelector(selectUserObject)
  const status = useSelector(selectUserCallStatus)
  const secondaryEmailRef = useRef(null)

  useEffect(() => {
    if (status === 'idle') {
      dispatch(fetchUser())
    }
  }, [status, dispatch])

  useEffect(() => {
    if (profile && values.secondEmail === '') {
      dispatch(setSecondaryEmail(profile.secondEmail || ''))
    }
  }, [profile])

  useEffect(() => {
    let id = null

    if (status !== 'loading') {
      id = setTimeout(() => {
        secondaryEmailRef.current?.focus()
      }, 0)
    }

    return () => {
      if (id !== null) {
        clearTimeout(id)
      }
    }
  }, [status])

  const {
    validFields,
    validateChange,
    handleBlur,
    isFormValid,
  } = EditAccountContainer({ t })

  const handleCancel = () => {
    if (profile) {
      dispatch(setSecondaryEmail(profile.secondEmail || ''))
    }
    navigate('/account')
  }

  const handleChange = (e) => {
    const { name, value } = e.target
    validateChange('secondEmail', value)
    if (name === 'secondEmail') dispatch(setSecondaryEmail(value))
  }

  const handleSubmit = (e) => {
    e.preventDefault()
    const secondEmailObj = {
      secondEmail: values.secondEmail
    }

    dispatch(updateUser(secondEmailObj))
      .unwrap()
      .then(() => navigate('/account', { state: { editSecondaryEmailStatus: 'true' } }))
  }

  return (
    <MarginWrapper>

      {isMobileView() ? (
        <EditSecondaryEmailMobile
          t={t}
          userFields={values}
          validFields={validFields}
          validateChange={validateChange}
          handleBlur={handleBlur}
          handleChange={handleChange}
          handleSubmit={handleSubmit}
          onCancel={handleCancel}
          isFormValid={isFormValid}
          status={status}
          secondaryEmailRef={secondaryEmailRef}
        />
      ) : (
        <EditSecondaryEmailDesktop
          t={t}
          userFields={values}
          validFields={validFields}
          validateChange={validateChange}
          handleBlur={handleBlur}
          handleChange={handleChange}
          handleSubmit={handleSubmit}
          onCancel={handleCancel}
          isFormValid={isFormValid}
          status={status}
          secondaryEmailRef={secondaryEmailRef}
        />

      )}
    </MarginWrapper>
  )
}
